import PropTypes from 'prop-types';

import Icon from './utils/Icon.js';
import {
  THEMATIQUE_TYPES_FIELDS_BY_ID,
  THEMATIQUE_TYPES_ICON_BY_ID,
  THEMATIQUE_TYPES_LABEL_BY_ID,
} from './ThematiqueTypes.js';
import BlocOperateur from './BlocOperateur.js';
import FieldSelect from './FieldSelect.js';
import CritereList from './CritereList.js';
import { useRechercheExperte } from './RechercheExperteProvider.js';
import { useDrag, useDrop } from 'react-dnd';

const DND_TYPE = 'BLOC_THEMATIQUE';

const BlocThematique = ({ bloc, showOperateur }) => {
  const {
    removeBloc,
    updateOperateur,
    addCritere,
    removeCritere,
    updateCritereValue,
    moveBloc,
  } = useRechercheExperte();
  const [{ isDragging }, dragRef] = useDrag(
    () => ({
      type: DND_TYPE,
      item: bloc,
      collect: (monitor) => ({
        draggedItem: monitor.getItem(),
        isDragging: !!monitor.isDragging(),
      }),
    }),
    [bloc.id, bloc.position],
  );

  const [{ isOver, canDrop, dropLeft }, dropRef] = useDrop(
    () => ({
      accept: DND_TYPE,
      drop: (item) => moveBloc(item, bloc),
      canDrop: (item) => bloc.id !== item.id,
      collect: (monitor) => ({
        isOver: !!monitor.isOver(),
        canDrop: !!monitor.canDrop(),
        dropLeft:
          monitor.getItem() && monitor.getItem().position > bloc.position,
      }),
    }),
    [bloc.id, bloc.position],
  );

  return (
    <div
      className={`bloc-thematique ${isDragging ? 'is-dragging' : ''}`}
      ref={dropRef}
    >
      {isOver && canDrop && dropLeft ? (
        <>
          {showOperateur ? (
            <div className="bloc-thematique-operateur-dnd-preview"></div>
          ) : null}
          <div className="bloc-thematique-filtres-dnd-preview"></div>
        </>
      ) : null}
      {showOperateur || (isOver && canDrop && dropLeft) ? (
        <BlocOperateur
          operateur={bloc.operateur}
          onChange={(operateur) => updateOperateur(bloc.id, operateur)}
        />
      ) : null}
      <div className="bloc-thematique-filtres" ref={dragRef}>
        <button
          type="button"
          className="bloc-thematique-close"
          onClick={() => removeBloc(bloc.id)}
        >
          &times;
        </button>
        <h2 className="bloc-thematique-label">
          <Icon
            name={THEMATIQUE_TYPES_ICON_BY_ID[bloc.thematiqueType]}
            className="bloc-thematique-icon"
          />
          {THEMATIQUE_TYPES_LABEL_BY_ID[bloc.thematiqueType]}
        </h2>
        <CritereList
          criteres={bloc.criteres}
          onRemove={(critereId) => removeCritere(bloc.id, critereId)}
          onUpdateValue={(critereId, value) =>
            updateCritereValue(bloc.id, critereId, value)
          }
        />
        <FieldSelect
          fields={THEMATIQUE_TYPES_FIELDS_BY_ID[bloc.thematiqueType]}
          onSelect={(fieldId) => addCritere(bloc.id, fieldId)}
        />
      </div>
      {isOver && canDrop && !dropLeft ? (
        <>
          <div className="bloc-thematique-operateur-dnd-preview"></div>
          <div className="bloc-thematique-filtres-dnd-preview"></div>
        </>
      ) : null}
    </div>
  );
};
BlocThematique.propTypes = {
  bloc: PropTypes.object.isRequired,
  showOperateur: PropTypes.bool.isRequired,
};

export default BlocThematique;
